// @module AGSuite.HeaderCustomization.HeaderCustomization
define('AGSuite.HeaderCustomization.HeaderCustomization.View'
,	[
	'agsuite_headercustomization_headercustomization.tpl'	
	,	'Backbone'
    ]
, function (
	agsuite_headercustomization_headercustomization_tpl
	,	Backbone
)
{
    'use strict';

	// @class AGSuite.HeaderCustomization.HeaderCustomization.View @extends Backbone.View
	return Backbone.View.extend({

		template: agsuite_headercustomization_headercustomization_tpl

	,	initialize: function (options) {

			/*  Uncomment to test backend communication with an example service
				(you'll need to deploy and activate the extension first)
			*/

			// this.model = new HeaderCustomizationModel();
			// var self = this;
         	// this.model.fetch().done(function(result) {
			// 	self.message = result.message;
			// 	self.render();
      		// });
		}

	,	events: {
		}

	,	bindings: {
		}

	, 	childViews: {

		}

		//@method getContext @return AGSuite.HeaderCustomization.HeaderCustomization.View.Context
	,	getContext: function getContext()
		{
			//@class AGSuite.HeaderCustomization.HeaderCustomization.View.Context
			this.message = this.message || 'Hello World!!'
			return {
				message: this.message
			};
		}
	});
});
